<template>
    <div>
        <a-drawer
            class="add-task-wrapper"
            :title="sessionInfo.duty_id ? $t('program.add_task.update_title' /* 修改任务 */) : $t('program.add_task.title' /* 添加任务 */)"
            width="50%"
            placement="right"
            :closable="true"
            :body-style="{ height: 'calc(100vh - 57px)', paddingBottom: '50px', overflow: 'auto' }"
            :visible="visible"
            @close="handleCloseEvent"
        >
            <a-spin :spinning="loading">
                <a-form :form="form">
                    <a-card size="small" :title="userType == 'cn' ? $t('program.add_task.attendance_info' /* 参会信息 */) : 'Attendance Information'" class="mb10">
                        <a-form-item :label="$t('program.add_task.date' /* 日期 */)" v-if="sessionInfo.duty_id && is_show_meeting">
                            <a-select v-decorator="['date_id', { rules: [{ required: true, message: $t('program.add_task.please_select_date' /* 请选择日期 */) }] }]">
                                <a-select-option v-for="item in dateList" :value="item.id" :key="item.id">{{ item.meeting_date }}</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item :label="$t('program.add_task.hall' /* 会场 */)" v-if="sessionInfo.duty_id && is_show_meeting">
                            <a-select v-decorator="['hall_id', { rules: [{ required: true, message: $t('program.add_task.please_select_hall' /* 请选择会场 */) }] }]">
                                <a-select-option v-for="item in hallList" :value="item.id" :key="item.id">{{ item.meeting_hall }}</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item :label="$t('program.add_task.session' /* Session */)" v-if="sessionInfo.duty_id && is_show_meeting">
                            <a-select v-decorator="['session_id', { rules: [{ required: true, message: $t('program.add_task.please_select_session' /* 请选择Session */) }] }]">
                                <a-select-option v-for="item in sessionList" :value="item.id" :key="item.id">
                                    {{ `${item.starttime_slot}-${item.endtime_slot} ${item.abstract_title}` }}
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item :label="userType == 'cn' ? $t('program.add_task.attending_by' /* 参会形式 */) : 'Attending by'">
                            <a-radio-group
                                name="teaching_form"
                                v-decorator="[
                                    'teaching_form',
                                    { rules: [{ required: true, message: $t('program.add_task.please_select_attending_by' /* 请选择参会形式 */) }], initialValue: 0 /* 默认单元 */ }
                                ]"
                            >
                                <a-radio-button v-for="(item, index) in joinList" :value="item.id" :key="item.id">
                                    {{ userType == 'cn' && $route.params.lang == 'cn' ? item.name : item.name_en }}
                                </a-radio-button>
                            </a-radio-group>
                        </a-form-item>
                        <a-form-item :label="userType == 'cn' ? $t('program.add_task.live_streaming_link' /* 直播链接 */) : 'Live Streaming Link'" v-show="form.getFieldValue('teaching_form') == 2">
                            <a-input v-decorator="['zoom_url']" />
                        </a-form-item>
                        <!-- 搜索用户 -->
                        <a-form-item>
                            <input type="hidden" v-decorator="['id', { rules: [{ required: true, message: $t('program.add_task.please_add_user_info' /* 请先添加人员信息 */) }] }]" />
                            <search-user
                                ref="searchUserRef"
                                :form="form"
                                :userInfo="userInfo"
                                :userType="userType"
                                searchUrl="getProgramSearchDuty"
                                @select="data => (selectedUserInfo = data)"
                            ></search-user>
                        </a-form-item>
                    </a-card>
                    <a-card size="small" :title="userType == 'cn' ? $t('program.add_task.honorarium_info' /* 劳务费信息 */) : 'Honorarium Information'" class="mb10">
                        <a-form-item :label="userType == 'cn' ? $t('program.add_task.whether_to_pay' /* 是否有劳务费 */) : 'Whether to pay'">
                            <a-radio-group name="is_servicefee" v-decorator="['is_servicefee', { initialValue: 0 }]" @change="handleIsServicefeeChange">
                                <a-radio-button :value="1">{{ userType == 'cn' ? $t('program.add_task.yes' /* 是 */) : 'Yes' }}</a-radio-button>
                                <a-radio-button :value="0">{{ userType == 'cn' ? $t('program.add_task.no' /* 否 */) : 'No' }}</a-radio-button>
                            </a-radio-group>
                        </a-form-item>
                        <a-form-item :label="userType == 'cn' ? $t('program.add_task.currency_type' /* 币种 */) : 'Currency Type'" v-show="form.getFieldValue('is_servicefee') == 1">
                            <a-select
                                v-decorator="[
                                    'currency',
                                    { rules: [{ required: form.getFieldValue('is_servicefee') == 1 ? true : false, message: $t('program.add_task.please_select_currency_type' /* 请选择币种 */) }] }
                                ]"
                            >
                                <a-select-option v-for="(item, index) in currencyTypeList" :value="item.id" :key="item.id">{{ item.name }}</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item :label="userType == 'cn' ? $t('program.add_task.service_fee_amount' /* 劳务费金额 */) : 'Honorarium Amount'" v-show="form.getFieldValue('is_servicefee') == 1">
                            <a-input
                                v-decorator="[
                                    'servicefee',
                                    {
                                        rules: [
                                            {
                                                required: form.getFieldValue('is_servicefee') == 1 ? true : false,
                                                message: $t('program.add_task.please_input_service_fee_amount' /* 请输入劳务费金额 */)
                                            }
                                        ]
                                    }
                                ]"
                            ></a-input>
                        </a-form-item>
                    </a-card>
                    <a-card size="small" :title="userType == 'cn' ? $t('program.add_task.role_task_info' /* 角色任务信息 */) : 'Role/Task Information'" class="mb10">
                        <a-form-item :label="userType == 'cn' ? $t('program.add_task.role_task' /* 角色任务 */) : 'Role/Task'">
                            <a-radio-group
                                v-decorator="[
                                    'type_id',
                                    { rules: [{ required: true, message: $t('program.add_task.please_select_role_task' /* 请选择角色任务 */) }], initialValue: typeInitValueFun() }
                                ]"
                            >
                                <a-radio-button v-for="(item, index) in fayanList" :value="item.id" :key="item.id">
                                    {{ userType == 'cn' && $route.params.lang == 'cn' ? item.typename_cn : item.typename_en }}
                                </a-radio-button>
                            </a-radio-group>
                        </a-form-item>
                    </a-card>
                    <a-card size="small" :title="userType == 'cn' ? $t('program.add_task.responsible_person' /* 负责人信息 */) : 'Responsible Person'">
                        <a-form-item :label="userType == 'cn' ? $t('program.add_task.responsible' /* 负责人 */) : 'Contact'">
                            <a-select v-decorator="['follow_user_id']">
                                <a-select-option v-for="(item, index) in fzrList" :value="item.id" :key="item.id">{{ item.real_name }}</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item :label="userType == 'cn' ? $t('program.add_task.remarks_admin' /* 备注 */) : 'Note'">
                            <a-textarea v-decorator="['remarks_admin']" :rows="2"></a-textarea>
                        </a-form-item>
                    </a-card>
                </a-form>
            </a-spin>
            <div
                class="t-r"
                :style="{
                    position: 'absolute',
                    left: '0px',
                    bottom: '0px',
                    height: '50px',
                    width: '100%',
                    borderTop: '1px solid #e9e9e9',
                    padding: '10px 16px',
                    background: '#fff',
                    textAlign: 'right',
                    zIndex: '100'
                }"
            >
                <a-button type="default" @click="handleCancelEvent">{{ $t('web.cancel' /* 取消 */) }}</a-button>
                <a-button class="ml10" type="primary" @click="handleSaveEvent('save')">{{ $t('program.add_task.save' /* 保存 */) }}</a-button>
                <a-button class="ml10" type="primary" @click="handleSaveEvent('continue')">{{ $t('program.add_task.save_and_continue' /* 保存并继续 */) }}</a-button>
            </div>
        </a-drawer>
    </div>
</template>
<script>
import SearchUser from '@/components/search-user';
import pick from 'lodash/pick';

const fields = ['date_id', 'hall_id', 'session_id', 'teaching_form', 'is_servicefee', 'currency', 'servicefee', 'type_id', 'follow_user_id', 'remarks_admin'];
export default {
    name: 'AddTaskDrawer',
    components: { SearchUser },
    props: {
        sessionList: {
            type: Array,
            default: function () {
                return [];
            }
        },
        dateList: {
            type: Array,
            default: function () {
                return [];
            }
        },
        hallList: {
            type: Array,
            default: function () {
                return [];
            }
        },
        is_show_meeting: {
            // 是否显示日期|会场|session
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            sessionInfo: {},
            visible: false,
            form: this.$form.createForm(this),
            currencyTypeList: [], // 币种列表
            joinList: [], // 参会形式
            fzrList: [], // 负责人列表
            fayanList: [], // 角色任务
            loading: false,
            userInfo: {},
            userType: '',
            selectedUserInfo: {} // 选中的任务人
        };
    },
    methods: {
        async show(data) {
            this.visible = true;
            this.sessionInfo = data;
            this.userType = this.sessionInfo.lang;
            this.loading = true;
            const apiList = [this.getProgramFormListFun(), this.getProgramFayanListFun()];
            if (this.sessionInfo.duty_id) {
                apiList.push(this.getDutyInfo());
            }
            Promise.all(apiList)
                .then(([res1, res2, res3]) => {
                    this.currencyTypeList = res1.data.currency_type;
                    this.joinList = res1.data.join_participation;
                    this.fzrList = res1.data.fzr_list;
                    this.fayanList = res2.data.map(item => {
                        item.id = parseInt(item.id);
                        return item;
                    });
                    if (res3) {
                        this.$nextTick(() => {
                            this.form.setFieldsValue(pick(res3.data, fields));
                            this.userInfo = res3.data;
                            this.userType = this.userInfo.country_id == 43 ? 'cn' : 'en';
                            this.userInfo.id = this.userInfo.user_id;
                        });
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        /**
         * ## 关闭抽屉
         */
        handleCloseEvent() {
            this.form.resetFields();
            this.$refs.searchUserRef.reset();
            this.userInfo = {};
            this.visible = false;
        },
        /**
         * ## 保存
         */
        handleSaveEvent(type) {
            this.form.validateFields((err, values) => {
                if (!err) {
                    this.loading = true;
                    this.$request
                        .post({
                            url: 'saveProgramDuty',
                            data: {
                                customid: this.sessionInfo.id,
                                duty_id: this.sessionInfo.duty_id,
                                program_id: this.sessionInfo.program_id,
                                userid: values.id,
                                sys_uid: values.id,
                                ...values
                            }
                        })
                        .then(res => {
                            const { code, data, message } = res;
                            if (code == 200) {
                                this.$message.success(this.$t('program.add_task.operation_success' /* 操作成功 */));
                                if (type == 'save') {
                                    this.form.resetFields();
                                    this.$refs.searchUserRef.reset();
                                    this.visible = false;
                                }
                                this.$emit('refresh');
                            } else {
                                this.$message.success(message);
                            }
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                } else {
                    this.form.validateFieldsAndScroll();
                }
            });
        },
        // 获取下拉列表
        getProgramFormListFun() {
            return this.$request.get({ url: 'getProgramFormList', data: { add_language: this.sessionInfo.lang, session_id: this.sessionInfo.id } }).then(res => {
                return res;
            });
        },
        /**
         * ## 获取发言类型列表
         */
        getProgramFayanListFun() {
            return this.$request.get({ url: 'getProgramFayanList', data: { type: this.sessionInfo.type } }).then(res => {
                return res;
            });
        },
        /**
         * ## 获取日程任务详情信息
         */
        getDutyInfo() {
            return this.$request.get({ url: 'getDutyInfo', data: { duty_id: this.sessionInfo.duty_id } }).then(res => {
                return res;
            });
        },
        /**
         * 设置角色任务默认值
         */
        typeInitValueFun() {
            if (this.fayanList.length) {
                const found = this.fayanList.find(item => item.id == this.sessionInfo.type_id);
                return found?.id || null;
            }
        },
        /**
         * 关闭抽屉
         */
        handleCancelEvent() {
            this.form.resetFields();
            this.$refs.searchUserRef.reset();
            this.visible = false;
        },
        /**
         * 劳务费是否显示
         */
        handleIsServicefeeChange(e) {
            this.form.setFieldsValue({ currency: undefined, servicefee: '' });
        }
    }
};
</script>
<style lang="less" scoped>
:deep(.ant-card-head) {
    background: #fafafa;
    .ant-card-head-title {
        font-weight: bold;
    }
}
.ant-form-item {
    margin-bottom: 0px;
}
:deep(.ant-form-item-label) {
    line-height: 2;
}
</style>
